import { ThunkAction } from 'redux-thunk';
import { AxiosResponse } from 'axios';
import store from 'store';
import ApiClient, { createTokenConfig, isCancelled } from 'api/ApiClient';
import { NotificationsAction, showError } from '@spike/notifications-action';
import {
    BOOKINGS_INSIGHTS_REPORT_GET_START,
    BOOKINGS_INSIGHTS_REPORT_GET_SUCCESS,
    BOOKINGS_INSIGHTS_REPORT_GET_ERROR,
    BookingsInsightsReportAction
} from './BookingsInsightsReportActionsTypes';
import { BookingsInsightsReportDto } from './BookingsInsightsReportDto';
import { convertToBookingInsightsReport } from './bookingInsightsReportConverter';

export const getBookingsInsightsReport = (
    start?: string,
    end?: string
): ThunkAction<void, null, null, BookingsInsightsReportAction | NotificationsAction> => {
    return async dispatch => {
        dispatch(getBookingsInsightsReportStart());

        const { marketplaceId } = store.getState().login.auth;
        let url = `/bookings_insights_report?marketplace_id=${marketplaceId}`;

        if (start) url += `&start_date=${start}`;
        if (end) url += `&end_date=${end}`;

        try {
            const response: AxiosResponse<BookingsInsightsReportDto> = await ApiClient.get(
                url,
                createTokenConfig(store.getState().login.auth.token!)
            );
            dispatch(getBookingsInsightsReportSuccess(response.data));
        } catch (apiError) {
            if (!isCancelled(apiError)) {
                dispatch(error());
                dispatch(showError('Too many bookings to display. Please try a shorter date range.'));
            }
        }
    };
};

const getBookingsInsightsReportStart = (): BookingsInsightsReportAction => ({
    type: BOOKINGS_INSIGHTS_REPORT_GET_START
});

const getBookingsInsightsReportSuccess = (response: BookingsInsightsReportDto): BookingsInsightsReportAction => {
    const insightsReportConverted = convertToBookingInsightsReport(response);
    return {
        type: BOOKINGS_INSIGHTS_REPORT_GET_SUCCESS,
        payload: {
            insights: insightsReportConverted
        }
    };
};

const error = (): BookingsInsightsReportAction => ({ type: BOOKINGS_INSIGHTS_REPORT_GET_ERROR });
